import { range } from 'lodash'


export * from './auth'
export * from './time'
export * from './data-job'
export * from './format'
export { default as shouldUpdateCheck } from './should-update'

export const getQuery = (search, key) => (new URLSearchParams(search)).get(key)

export const calculateRange = (steps) => {
  const min = 25
  const max = 95
  const range = Math.floor((max - min) / (steps - 1 || 1))
  return [...Array(steps).keys()].reduce((prev, cur) => [...prev, min + (range * cur)], [])
}

export const shadeBlend = (p, c0, c1) => {
  const n = p < 0 ? p * -1 : p
  const u = Math.round
  const w = parseInt
  if (c0.length > 7) {
    const f = c0.split(',')
    const t = (c1 || (p < 0 ? 'rgb(0,0,0)' : 'rgb(255,255,255)')).split(',')
    const R = w(f[0].slice(4))
    const G = w(f[1])
    const B = w(f[2])
    /* eslint-disable max-len */
    return `rgb(${u((w(t[0].slice(4)) - R) * n) + R},${u((w(t[1]) - G) * n) + G},${u((w(t[2]) - B) * n) + B})`
  }
  const f = w(c0.slice(1), 16)
  const t = w((c1 || (p < 0 ? '#000000' : '#FFFFFF')).slice(1), 16)
  /* eslint-disable no-bitwise */
  /* eslint-disable no-mixed-operators */
  const R1 = f >> 16
  const G1 = f >> 8 & 0x00FF
  const B1 = f & 0x0000FF
  return `#${(0x1000000 + (u(((t >> 16) - R1) * n) + R1) * 0x10000 + (u(((t >> 8 & 0x00FF) - G1) * n) + G1) * 0x100 + (u(((t & 0x0000FF) - B1) * n) + B1)).toString(16).slice(1)}`
}

export const createGeoJSONCircle = (center, km) => {
  const points = 64
  const dx = km / (111.32 * Math.cos(center.Latitude * Math.PI / 180))
  const dy = km / 110.574

  const res = range(points).map((i) => {
    const theta = (i / points) * (2 * Math.PI)
    const x = dx * Math.cos(theta)
    const y = dy * Math.sin(theta)
    return [center.Longitude + x, center.Latitude + y]
  })

  res.push(res[0])

  return {
    type: 'geojson',
    data: {
      type: 'Polygon',
      coordinates: [res],
    },
  }
}
